import { StrictMode } from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router';

import App from './app';
import { store } from './store';
import { getRoutesSection } from './routes/sections';
import { initDatadog } from './observability/datadog';
import { getConfig, loadConfig } from './global-config';
import { initBrowserPolyfills } from './utils/polyfills';
import { initAnalytics } from './observability/analytics';
import { registerStaleChunkReload } from './utils/checkversion';
import { ErrorBoundary, ErrorBoundaryProd } from './routes/components';
import { setupAdaptiveViewportScale } from './utils/responsive-viewport';

const root = createRoot(document.getElementById('root')!);

(async function startApp() {
  try {
    registerStaleChunkReload();

    initBrowserPolyfills();
    setupAdaptiveViewportScale();
    await loadConfig();
    initDatadog();
    initAnalytics();

    const isProdErrorUi = getConfig().appMode === 'production';

    // if (isWebGPUSupported()) {
    //   void initWebLLM().catch((err) => {
    //     console.error('[webllm] Background initialization failed:', err);
    //   });
    // }

    const routesSection = getRoutesSection();

    const router = createBrowserRouter([
      {
        Component: () => (
          <App>
            <Outlet />
          </App>
        ),
        errorElement: isProdErrorUi ? <ErrorBoundaryProd /> : <ErrorBoundary />,
        children: routesSection,
      },
    ]);

    root.render(
      <StrictMode>
        <Provider store={store}>
          <HelmetProvider>
            <RouterProvider router={router} />
          </HelmetProvider>
        </Provider>
      </StrictMode>
    );
  } catch (err) {
    console.error('Failed to start app:', err);
    // Optionally show fallback UI or error screen here
  }
})();
